import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { B2C_DISCLAIMER, BUSINESS_NAME, HUB_PATHS, SITE_VERSION, YBERA_AFFILIATE_HOME } from "@/lib/site";

const LINKS = [
  { to: HUB_PATHS.progressiva, label: "Progressiva Fashion Gold" },
  { to: HUB_PATHS.progressivaOficial, label: "Comprar original" },
  { to: HUB_PATHS.cronograma, label: "Cronograma capilar" },
  { to: HUB_PATHS.oleoMirra, label: "Óleo de Mirra" },
  { to: HUB_PATHS.antiqueda, label: "100Tímetros" },
  { to: HUB_PATHS.soroVello, label: "Soro Vital Vello" },
];

const PAYMENTS = [
  { src: "/trust/visa.png", alt: "Visa" },
  { src: "/trust/mastercard.png", alt: "Mastercard" },
  { src: "/trust/elo.png", alt: "Elo" },
  { src: "/trust/amex.png", alt: "American Express" },
  { src: "/trust/pix.png", alt: "Pix" },
] as const;

const SECURITY = [
  { src: "/trust/site-seguro.png", alt: "Site 100% seguro" },
  { src: "/trust/site-seguro-google.png", alt: "Site seguro by Google" },
  { src: "/trust/geotrust.png", alt: "Secured by GeoTrust" },
  { src: "/trust/abcomm.png", alt: "Empresa Premium ABCOMM" },
] as const;

function BadgeRow({
  title,
  items,
}: {
  title: string;
  items: readonly { src: string; alt: string }[];
}) {
  return (
    <div>
      <h2 className="mb-2 text-sm font-semibold text-white">{title}</h2>
      <ul className="flex flex-wrap items-center gap-2">
        {items.map((item) => (
          <li key={item.src}>
            <img src={item.src} alt={item.alt} width={48} height={24} className="h-6 w-auto rounded-[2px]" loading="lazy" decoding="async" />
          </li>
        ))}
      </ul>
    </div>
  );
}

export function Footer() {
  return (
    <footer className="border-t border-border bg-secondary text-secondary-foreground">
      <div className="container grid gap-8 py-12 md:grid-cols-3">
        <div>
          <img src="/logo.webp" alt={BUSINESS_NAME} width={215} height={62} className="mb-4 h-10 w-auto brightness-0 invert" loading="lazy" decoding="async" />
          <p className="max-w-sm text-sm text-white/75">
            Parceiro oficial Ybera. Escolha o produto Fashion Gold e compre na loja oficial da marca com nosso desconto
            especial, com nota fiscal da Ybera Group.
          </p>
        </div>
        <div>
          <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-primary-onDark">Mais Queridinhos</h2>
          <ul className="space-y-2 text-sm">
            {LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-white/80 hover:text-white">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-primary-onDark">Loja oficial</h2>
          <a
            href={YBERA_AFFILIATE_HOME}
            rel="sponsored noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-onDark hover:text-white"
          >
            ybera.com
            <ExternalLink className="h-3.5 w-3.5" aria-hidden />
          </a>
          <p className="mt-2 text-sm text-white/75">
            Compre na Loja Ybera Oficial com nosso Cupom de Desconto especial parceiro 32566.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container grid gap-8 py-8 md:grid-cols-2">
          <BadgeRow title="Pagamento" items={PAYMENTS} />
          <BadgeRow title="Segurança" items={SECURITY} />
        </div>
      </div>
      <div className="border-t border-white/10 px-6 py-5 text-center text-xs leading-relaxed text-white/80">
        <p>{B2C_DISCLAIMER}</p>
        <p className="mt-2">
          <Link to="/politica-de-privacidade/" className="underline-offset-2 hover:underline">
            Política de privacidade
          </Link>
          <span className="mx-2" aria-hidden>
            ·
          </span>
          <Link to="/reembolso_devolucoes/" className="underline-offset-2 hover:underline">
            Reembolso e devoluções
          </Link>
        </p>
        <p className="mt-2">
          © {new Date().getFullYear()} {BUSINESS_NAME} · v{SITE_VERSION}
        </p>
      </div>
    </footer>
  );
}
